import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React__default from 'react';
import SlideModuleCss from './index.module.css.js';
import Background from './Background/index.js';
import Mask from './Mask/index.js';
import { useManager } from '../../modules/Manager.js';
import { useController } from '../../modules/Controller.js';
import { useAnimations } from '../../modules/Animations.js';
import { composeCssClasses } from '../../utils/composeCssClasses.js';
import ConsoleLogger from '../../modules/ConsoleLogger.js';
var logger = ConsoleLogger.new();

function Slide(props) {
  var className = props.className,
      _props$shouldRenderMa = props.shouldRenderMask,
      shouldRenderMask = _props$shouldRenderMa === void 0 ? false : _props$shouldRenderMa,
      style = props.style,
      background = props.background,
      onBackgroundLoad = props.onBackgroundLoad,
      children = props.children,
      label = props.label;

  var _useManager = useManager(),
      getSlide = _useManager.getSlide,
      registerSlide = _useManager.registerSlide,
      removeSlide = _useManager.removeSlide;

  var _useController = useController(),
      _useController$state = _useController.state,
      activeSlide = _useController$state.activeSlide,
      isSliding = _useController$state.isSliding,
      prevActiveSlide = _useController$state.prevActiveSlide,
      slidingDirection = _useController$state.slidingDirection; // controller


  var _useAnimations = useAnimations(),
      getSlidingAnimationCssClass = _useAnimations.getSlidingAnimationCssClass;

  var slideRef = React__default.useRef(null);
  var slide = getSlide(slideRef);
  logger.info('[Slide] rerender', 'slide.number: ', slide === null || slide === void 0 ? void 0 : slide.number);

  var _React__default$useSt = React__default.useState(composeCssClasses('hero-slider-slide', SlideModuleCss.Slide, className)),
      _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
      classNames = _React__default$useSt2[0],
      setClassNames = _React__default$useSt2[1];

  var isActive = activeSlide === (slide === null || slide === void 0 ? void 0 : slide.number);
  React__default.useEffect(function () {
    if (slide) {
      setClassNames(composeCssClasses('hero-slider-slide', SlideModuleCss.Slide, {
        className: SlideModuleCss.Active,
        useIf: isActive
      }, {
        className: SlideModuleCss.Sliding,
        useIf: isActive && !isSliding
      }, {
        className: getSlidingAnimationCssClass(slide.number, prevActiveSlide, slidingDirection),
        useIf: isActive && isSliding
      }));
    }
  }, [isActive, isSliding]);
  React__default.useEffect(function () {
    if (slideRef) registerSlide(slideRef, label);
    return function () {
      if (slideRef) removeSlide(slideRef);
    };
  }, []);
  if (!slide) return null;
  /**
   * CSS variables for the transitions.
   */

  var CSSVariables = {
    '--background-animation-duration': (background === null || background === void 0 ? void 0 : background.backgroundAnimationDuration) ? "".concat(background.backgroundAnimationDuration, "ms") : null,
    '--background-animation-delay': (background === null || background === void 0 ? void 0 : background.backgroundAnimationDelay) ? "".concat(background.backgroundAnimationDelay, "ms") : null
  };
  return React__default.createElement("div", {
    ref: slideRef,
    className: classNames,
    style: Object.assign(Object.assign({}, style), CSSVariables)
  }, React__default.createElement(Background, Object.assign({}, background, {
    onLoad: onBackgroundLoad
  })), React__default.createElement("div", {
    className: composeCssClasses('hero-slider-slide-wrapper', SlideModuleCss.Wrapper)
  }, shouldRenderMask ? React__default.createElement(Mask, {
    background: background,
    isActive: isActive
  }) : null, React__default.createElement("div", {
    className: composeCssClasses('hero-slider-slide-container', SlideModuleCss.Container, {
      className: SlideModuleCss.Active,
      useIf: isActive && !isSliding
    })
  }, children)));
}

Slide.displayName = 'hero-slider/slide';
export { Slide };